import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children, requiredRole = null, allowNoPassword = false }) => {
    const { isAuthenticated, user, isInitializing } = useAuth();
    const location = useLocation();

    // Show loading while checking authentication
    if (isInitializing) {
        return <LoadingSpinner />;
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check if password needs to be set (for OAuth users)
    if (user && user.isPasswordSet === false && !allowNoPassword) {
        return <Navigate to="/set-password" replace />;
    }

    // Check role if required
    if (requiredRole && user?.userType !== requiredRole) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;